import { render, staticRenderFns } from "./ServiceOrder.vue?vue&type=template&id=b1e4dc52&scoped=true&"
import script from "./ServiceOrder.vue?vue&type=script&lang=js&"
export * from "./ServiceOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e4dc52",
  null
  
)

export default component.exports